import { gql } from "@apollo/client";

export const CREATE_MAJOR = gql`
  mutation CreateMajors($input: MajorsInput) {
    createMajors(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_MAJOR_WITH_PAGINATION = gql`
  query GetMajorsPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getMajorsPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        majorsNameKh
        majorsNameEng
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_MAJOR = gql`
  mutation UpdateMajors($id: ID!, $input: MajorsInput) {
    updateMajors(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_MAJOR = gql`
  mutation DeleteMajors($id: ID!) {
    deleteMajors(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
